// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accept-invite {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-lg, 24px);
  background: var(--color-surface, #f3efe6);
  color: var(--color-text-primary, #5c636b);
  font-family: var(--font-family-primary, -apple-system, sans-serif);
}

.accept-invite__card {
  width: 100%;
  max-width: 480px;
  background: var(--color-surface-light, #faf8f3);
  border: 1px solid var(--color-border, #e8e3d8);
  border-radius: var(--border-radius-lg, 12px);
  box-shadow: var(--shadow-md);
  padding: var(--spacing-xl, 32px);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md, 16px);
}

.accept-invite__eyebrow {
  margin: 0;
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--color-accent, #b87333);
}

.accept-invite__card h1 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--color-primary, #1f2a44);
  line-height: 1.2;
}

.accept-invite__meta {
  margin: 0;
  color: var(--color-text-primary, #5c636b);
  font-size: 0.95rem;
}

.accept-invite__hint {
  margin: 0;
  font-size: 0.85rem;
  color: var(--color-text-secondary, #8a919b);
}

.accept-invite__error {
  padding: var(--spacing-sm, 8px) var(--spacing-md, 16px);
  background: rgba(212, 76, 76, 0.1);
  color: var(--color-error, #d44c4c);
  border-radius: var(--border-radius-sm, 4px);
  font-size: 0.9rem;
}

.accept-invite__actions {
  display: flex;
  gap: var(--spacing-sm, 8px);
  flex-wrap: wrap;
}

.accept-invite__btn {
  padding: 10px 18px;
  border: 1px solid var(--color-border, #e8e3d8);
  border-radius: var(--border-radius-sm, 4px);
  background: var(--color-surface-light, #fff);
  color: var(--color-text-primary, #5c636b);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 150ms;
}
.accept-invite__btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.accept-invite__btn--primary {
  background: var(--color-secondary, #4c6a58);
  color: #fff;
  border-color: transparent;
}

.accept-invite__linkbtn {
  background: none;
  border: none;
  padding: 0;
  color: inherit;
  text-decoration: underline;
  cursor: pointer;
  font: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AcceptInvitationPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,yCAAyC;EACzC,yCAAyC;EACzC,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,+CAA+C;EAC/C,8CAA8C;EAC9C,4CAA4C;EAC5C,4BAA4B;EAC5B,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uDAAuD;EACvD,kCAAkC;EAClC,kCAAkC;EAClC,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,8CAA8C;EAC9C,2CAA2C;EAC3C,4CAA4C;EAC5C,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,2CAA2C;EAC3C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,aAAa;AACf","sourcesContent":[".accept-invite {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: var(--spacing-lg, 24px);\n  background: var(--color-surface, #f3efe6);\n  color: var(--color-text-primary, #5c636b);\n  font-family: var(--font-family-primary, -apple-system, sans-serif);\n}\n\n.accept-invite__card {\n  width: 100%;\n  max-width: 480px;\n  background: var(--color-surface-light, #faf8f3);\n  border: 1px solid var(--color-border, #e8e3d8);\n  border-radius: var(--border-radius-lg, 12px);\n  box-shadow: var(--shadow-md);\n  padding: var(--spacing-xl, 32px);\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-md, 16px);\n}\n\n.accept-invite__eyebrow {\n  margin: 0;\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--color-accent, #b87333);\n}\n\n.accept-invite__card h1 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: var(--color-primary, #1f2a44);\n  line-height: 1.2;\n}\n\n.accept-invite__meta {\n  margin: 0;\n  color: var(--color-text-primary, #5c636b);\n  font-size: 0.95rem;\n}\n\n.accept-invite__hint {\n  margin: 0;\n  font-size: 0.85rem;\n  color: var(--color-text-secondary, #8a919b);\n}\n\n.accept-invite__error {\n  padding: var(--spacing-sm, 8px) var(--spacing-md, 16px);\n  background: rgba(212, 76, 76, 0.1);\n  color: var(--color-error, #d44c4c);\n  border-radius: var(--border-radius-sm, 4px);\n  font-size: 0.9rem;\n}\n\n.accept-invite__actions {\n  display: flex;\n  gap: var(--spacing-sm, 8px);\n  flex-wrap: wrap;\n}\n\n.accept-invite__btn {\n  padding: 10px 18px;\n  border: 1px solid var(--color-border, #e8e3d8);\n  border-radius: var(--border-radius-sm, 4px);\n  background: var(--color-surface-light, #fff);\n  color: var(--color-text-primary, #5c636b);\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: opacity 150ms;\n}\n.accept-invite__btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.accept-invite__btn--primary {\n  background: var(--color-secondary, #4c6a58);\n  color: #fff;\n  border-color: transparent;\n}\n\n.accept-invite__linkbtn {\n  background: none;\n  border: none;\n  padding: 0;\n  color: inherit;\n  text-decoration: underline;\n  cursor: pointer;\n  font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
